export const environment = {
  production: false,
};

export const API_USER_URL = 'https://user.stage.itg.iql.ru/api/v1';
export const API_USER_DISTRIBUTOR_URL = 'https://user.distributor.stage.itg.iql.ru/api/v1';
export const API_PLAN_URL = 'https://saleplan.stage.itg.iql.ru/api';
export const IMAGE_CLOUD_URL = 'https://static.cloud.stage.itg.iql.ru';
export const MARKET_CHAT_URL = 'https://chat.stage.itg.iql.ru';
export const MARKET_MESSAGING_WEBSOCKET_URL = 'wss://notifications.stage.itg.iql.ru/iq-messaging/socket/v1/';
export const NOTIFICATIONS_API_URL = 'https://notifications.stage.itg.iql.ru';
export const MARKET_FRONT_URL = 'https://stage.iqmarket.pro/';

